import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, reservation } from "@/mixins/index";
import updlotteryNumData from "./components/updlotteryNumData.vue";
export default {
  name: "lotteryNumData",
  mixins: [loadMoreList, reservation],
  components: {
    updlotteryNumData: updlotteryNumData
  },
  data: function data() {
    return {
      pagingReqFn: "lotteryNumData",
      pagingReqValue: "",
      drawer: false,
      delIds: []
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    viewOpen: function viewOpen(content) {
      this.content = this.$utils.textRepl(content);
      this.drawer = true;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'serverStateDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};